export { SemanticTypeLabel } from "./SemanticTypeLabel";
